import Checkbox from "components/FormElements/Checkbox";
import PrimaryButton from "components/Buttons/PrimaryButton";
import Input from "components/FormElements/Input";
import React, { memo, useCallback, useState, useContext } from "react";
import { UserApi } from "utils/api";
import { useNavigate } from "react-router-dom";
import { userContext } from "contextProviders/userContext";

const AuthForm = memo(() => {
  const navigate = useNavigate();

  const [childName, setChildName] = useState("");
  const [childSurname, setChildSurname] = useState("");
  const [childAge, setChildAge] = useState("");
  const [phone, setPhone] = useState("");
  const [code, setCode] = useState("");
  const [error, setError] = useState(null);
  const [conditions, setConditions] = useState(false);
  const [dataSending, setDataSending] = useState(false);
  const [sended, setSended] = useState(false);
  const { setUser } = useContext(userContext);

  const handleSendCode = useCallback(
    (e) => {
      e.preventDefault();

      if (phone.length === 11) {
        setDataSending(true);
        UserApi.register({
          msisdn: phone.slice(1),
          sender: "KNTSV_PLAZA",
          confirm: 1,
        })
          .then(() => {
            setError(null);
            setSended(true);
          })
          .catch((e) => {
            setError(e.response.data.error);
          })
          .finally(() => setDataSending(false));
      } else {
        setError("Заполните поле телефон");
      }
    },
    [phone]
  );

  const handleLogin = useCallback(
    (e) => {
      e.preventDefault();

      if (code && conditions && childName && childSurname && childAge) {
        setDataSending(true);
        UserApi.verify({
          msisdn: phone.slice(1),
          event_tag: "newyear24",
          password: code,
        })
          .then((res) => {
            setError(null);
            setUser({
              ...res,
              ...{
                childName: childName,
                childSurname: childSurname,
                childAge: childAge,
              },
            });
            navigate("/letter");
          })
          .catch((e) => {
            if (e.response && [400, 401].indexOf(e.response.status) !== -1) {
              setError(e.response.data.error);
            } else {
              setError("Ошибка связи с сервером");
            }
          })
          .finally(() => setDataSending(false));
      } else {
        setError("Заполните поля");
      }
    },
    [
      code,
      conditions,
      phone,
      childName,
      childSurname,
      childAge,
      setUser,
      navigate,
    ]
  );

  const handleHaveCode = useCallback(
    (e) => {
      e.preventDefault();
      if (phone.length === 11) setSended(true);
      else setError("Заполните поле телефон");
    },
    [phone]
  );

  return !sended ? (
    <form class="form  form--phone-number-1">
      <div class="wrapper  wrapper--green">
        {!error ? (
          <p class="form__txt">
            Введите корректный <br />
            номер телефона <br />
            или&nbsp;зарегистрируйтесь
          </p>
        ) : (
          <p class="form__txt">{error}</p>
        )}
        <Input
          className={"form__input"}
          value={phone}
          setValue={(value, mask) => setPhone(value)}
          required
          mask={"+{7}(000)000-00-00"}
          placeholder={"+7 (___) _________"}
        />
        <PrimaryButton
          callback={handleSendCode}
          disabled={dataSending}
          text={dataSending ? "Подождите..." : "Отправить"}
          className={"form__btn"}
        />
        <div className={"havecode-wrapper"}>
          <button onClick={handleHaveCode}>У меня есть код</button>
        </div>
      </div>
    </form>
  ) : (
    <form class="form  form--phone-number-2">
      <div class="wrapper  wrapper--yellow">
        {!error ? (
          <p class="form__txt orange">
            Введите ваши имя и&nbsp;фамилию и&nbsp;возраст вашего ребенка
          </p>
        ) : (
          <p class="form__txt orange">{error}</p>
        )}
        <Input
          mask={/^[а-я]+$/i}
          placeholder={"Имя"}
          value={childName}
          setValue={setChildName}
        />
        <Input
          mask={/^[а-я]+$/i}
          placeholder={"Фамилия"}
          value={childSurname}
          setValue={setChildSurname}
        />
        <Input
          mask={/^\d{0,2}$/}
          placeholder={"Возраст ребенка"}
          value={childAge}
          setValue={setChildAge}
        />
        <Checkbox
          id="conditions"
          checked={conditions}
          setChecked={setConditions}
          label={`Я согласен(а) с <a target="_blank" href="https://s3-eu-central-1.amazonaws.com/enka-panel/files/file_url/Hk9jrSp9D-pravila-programmy_kashirskaya_plaza.pdf?1606403490238">правилами</a>`}
        />
      </div>
      <div class="wrapper  wrapper--green">
        <p class="form__txt white">Введите код из&nbsp;SMS</p>
        <Input
          mask={"00000"}
          setValue={(value) => setCode(value)}
          placeholder="000000"
          required
        />
        <PrimaryButton
          callback={handleLogin}
          disabled={dataSending}
          text={"Отправить"}
          className={"form__btn"}
        />
      </div>
    </form>
  );
});

export default AuthForm;
